import React from 'react'

export const PlusIcon = ({ size = 21, color = '#5F6D7E' }: { size?: number; color?: string }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 21 20' fill='none'>
    <path
      d='M16.3334 10.8327H11.3334V15.8327H9.66669V10.8327H4.66669V9.16602H9.66669V4.16602H11.3334V9.16602H16.3334V10.8327Z'
      fill={color}
    />
  </svg>
)
